export default __webpack_public_path__ + "static/media/credit.ef77afdf.png";